var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-09-19
 * @brief SEI Management - 사용자 관리 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState } from "../../../recoil/assessmentState";
// useState
import { userInfoLoginState } from "../../../recoil/userState";
// useState
import { useNavigate } from "react-router-dom";
import { getApiLangState } from "../../../recoil/langState";
import { loadingBoxState } from "../../../recoil/menuState";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
/**
 * @brief EHP 사용자 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
export default function UserView(props) {
    // 화면 이동
    const navigate = useNavigate();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const langApi = useRecoilValue(getApiLangState);
    // props
    const { handleOpenPop, selTree } = props;
    // useState
    const [changeTree, setChangeTree] = useState(null);
    const [load, setload] = useState(false);
    const [reload, setReload] = useState(false);
    const [userLoad, setUserLoad] = useState(false);
    const [userDisplayDone, setUserDisplayDone] = useState(false);
    const [userDisplayCompanion, setUserDisplayCompanion] = useState(false);
    const [userType, setUserType] = useState(null);
    const [addList, setAddList] = useState([]);
    const [addListResult, setAddListResult] = useState([]);
    const [checked, setChecked] = useState(false);
    const [errorList, setErrorList] = useState([]);
    const [companyItem, setCompanyItem] = useState([]);
    const [companyAdd, setCompanyAdd] = useState([]);
    const [zoneItem, setZoneItem] = useState([]);
    const [zoneAdd, setZoneAdd] = useState([]);
    const [user, setUser] = useState(null);
    const [role, setRole] = useState("");
    const [users, setUsers] = useState([]);
    const [addListResultData, setAddListResultData] = useState([]);
    const [enableItem, setEnableItem] = useState(false);
    const [sortData, setSortData] = useState({
        sortField: "rownumber",
        sort: "asc",
    });
    const [enabled, setEanbled] = useState(false);
    const [zoneName, setZoneName] = useState("");
    const [alert, setAlert] = useRecoilState(alertState);
    const [userTypeItme, setUserTypeItme] = useState(null);
    const roleType = [
        {
            id: "0",
            value: CONST.USERROLE_NONE,
            fname: "NONE" /* active: false */,
        },
        {
            id: "1",
            value: CONST.USERROLE_ADMIN,
            fname: "Admin" /* active: false */,
        },
        {
            id: "2",
            value: CONST.USERROLE_ENGINEER,
            fname: "Engineer" /* active: false */,
        },
        {
            id: "3",
            value: CONST.USERROLE_SUPER,
            fname: "Super User" /* active: false */,
        },
        {
            id: "4",
            value: CONST.USERROLE_USER,
            fname: "User" /* active: false */,
        },
    ];
    // 페이징
    const defaultPageInfo = {
        size: 10,
        totalElements: 0,
        totalPages: 0,
        number: 0,
    };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    // appPath
    let appPath = "companyName=" + selTree.company.companyName + "&page=" + pageInfo.number + "&size=" + pageInfo.totalElements;
    appPath = appPath + "&sort=" + sortData.sortField + "," + sortData.sort;
    // 중복제거 이벤트
    const addLists = addList.filter((arr, index, callback) => index === callback.findIndex((t) => t.zoneId === arr.zoneId));
    // 신규 가입 요청 팝업
    useEffect(() => {
        handleOpenPop("pop-admin-ok", _jsx(RequestApproval, { user: user, setload: setload, addListResult: addListResult, setAddListResult: setAddListResult, addListResultData: addListResultData, setAddListResultData: setAddListResultData, checked: checked, setChecked: setChecked, userType: userType, setUserType: setUserType, userDisplayDone: userDisplayDone, setUserDisplayDone: setUserDisplayDone, userDisplayCompanion: userDisplayCompanion, setUserDisplayCompanion: setUserDisplayCompanion, roleType: roleType, errorList: errorList, setErrorList: setErrorList, setAddList: setAddList, 
            //
            reload: reload, setReload: setReload, setEnableItem: setEnableItem, enableItem: enableItem, userLoad: userLoad, setUserLoad: setUserLoad, 
            //
            companySelect: companySelect, approvalChang: approvalChang, listDelete: listDelete, userTypeSelect: userTypeSelect, onCompanion: onCompanion, onDone: onDone, usertypePop: usertypePop, htmlClose: _jsxs(_Fragment, { children: [user && (_jsxs("h1", { children: ["\uC2E0\uADDC \uAC00\uC785\uC790 _ ", user.userName, " ", user.approval < 3 && !enabled ? "(미인증)" : ""] })), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-admin-ok") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
    }, [
        user,
        addListResult,
        addListResultData,
        checked,
        userType,
        userDisplayDone,
        userDisplayCompanion,
        errorList,
        reload,
        enableItem,
        userLoad,
    ]);
    useEffect(() => {
        // 신규 가입자 정보 팝업 (웹,탭용 팝업)
        handleOpenPop("pop-user-add", _jsx(CompanyZoneCreatePop, { user: user, userType: userType, addListResult: addListResult, listAdd: listAdd, listDelete: listDelete, companyClick: companyClick, companyItem: companyItem, setCompanyItem: setCompanyItem, companyAdd: companyAdd, setCompanyAdd: setCompanyAdd, zoneItem: zoneItem, setZoneItem: setZoneItem, zoneAdd: zoneAdd, setZoneAdd: setZoneAdd, addList: addList, setAddList: setAddList, setAddListResult: setAddListResult, addLists: addLists, addListResultData: addListResultData, zoneClick: zoneClick, htmlClose: _jsxs(_Fragment, { children: [user && (_jsxs("h1", { children: ["\uC2E0\uADDC \uAC00\uC785\uC790 _ ", user.userName, " ", user.approval <= 2 && !enabled ? "(미인증)" : ""] })), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CloseInnerPop("pop-user-add") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
    }, [user, userType, addListResult, companyItem, companyAdd, zoneItem, zoneAdd, addList, addListResultData]);
    useEffect(() => {
        handleOpenPop("pop-password", _jsx(PassswordPop, { user: user, setReload: setReload, htmlClose: _jsx(_Fragment, { children: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CloseInnerPop("pop-password") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }) }));
        handleOpenPop("pop-enabled", _jsx(EnabledPop, { user: user, setReload: setReload, enableItem: enableItem, setEnableItem: setEnableItem, htmlClose: _jsx(_Fragment, { children: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CloseInnerPop("pop-enabled") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }) }));
        handleOpenPop("pop-unlock", _jsx(UnlockPop, { user: user, setUser: setUser, setReload: setReload, htmlClose: _jsx(_Fragment, { children: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CloseInnerPop("pop-unlock") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }) }));
        handleOpenPop("pop-role", _jsx(RolePop, { user: user, setReload: setReload, userTypeDel: userTypeDel, userTypeItme: userTypeItme, htmlClose: _jsx(_Fragment, { children: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CloseInnerPop("pop-role") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }) }));
    }, [user, enableItem, userTypeItme]);
    // 사업장 조회
    if (!CUTIL.isnull(zoneName) && zoneName.length > 0) {
        appPath = appPath + "&zoneName=" + zoneName;
    }
    // 사용자 Type 조회
    if (!CUTIL.isnull(role) && role.length > 0) {
        appPath = appPath + "&role=" + role;
    }
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
    }
    const CloseInnerPop = (id) => {
        setAddListResult([]);
        CUTIL.inner_jsclose_Popup(id);
    };
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/users?${appPath}`,
        userToken: userInfo.loginInfo.token,
        watch: appPath + selTree.reload + reload + enableItem + userLoad + load,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChangeTree(selTree);
                setUsers(data.body);
                setPageInfo(data.data.page);
                if (changeTree && changeTree !== selTree) {
                    setRole("");
                    setSortData({
                        sortField: "rownumber",
                        sort: "asc",
                    });
                }
            }
            else {
                if (data.errorList.filter((err) => err.field == "companyName")) {
                    // window.location.reload();
                }
                else {
                    const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
                    if (ERR_URL.length > 0)
                        navigate(ERR_URL);
                }
            }
        }
    }, [data, changeTree]);
    function onClickSort(e) {
        var actTag = e.target.tagName == "TH" ? e.target : e.currentTarget;
        var selSortField = actTag.getAttribute("data-value");
        var selSort = sortData.sort === "asc" ? "DESC" : "asc";
        if (selSortField !== sortData.sortField) {
            // 정렬필드가 변경된 경우
            selSort = "DESC";
        }
        handleCurPage(0);
        setSortData({
            sortField: selSortField,
            sort: selSort,
        });
    }
    // 신규 가입자 승인 요청 API
    function approvalPop(e, user) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/user/${user.userIdPk}/detail`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: user.userIdPk,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setUser(data.body);
                    setEanbled(user.enable);
                    setEnableItem(user.enable);
                    setAddListResultData(data.body.userTreeList);
                    CUTIL.jsopen_Popup(e);
                    if (data.body.approval == 2) {
                        setUserDisplayDone(true);
                    }
                    else {
                        setUserDisplayDone(false);
                    }
                    setUserDisplayCompanion(false);
                    userTypeSelect(user.role);
                    setUserType(user.role);
                }
            }
        });
    }
    // 사용자 타입
    function userTypeSelect(type) {
        setErrorList(errorList.filter((err) => err.field !== "role"));
        setUserType(type.value);
        setChecked(true);
        if (type !== userType) {
            setAddList([]);
            setAddListResult([]);
        }
    }
    // 사용자가 사용자 타입을 바뀌면서 걸려있던 usertree 삭제
    function userTypeDel(type) {
        return __awaiter(this, void 0, void 0, function* () {
            if (addListResultData.length > 0) {
                let data = [];
                let success = [];
                let fail = [];
                setRecoilIsLoadingBox(true);
                for (let i = 0; i < addListResultData.length; i++) {
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "DELETE",
                        appPath: `/product/usertree/user/${user.id}`,
                        appQuery: {
                            productId: addListResultData[i].productId,
                        },
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            success.push(data.body);
                        }
                        else {
                            fail.push(data.errorList);
                        }
                    }
                }
                if (data) {
                    if (success.length > 0) {
                        userTypeSelect(type);
                        setReload(true);
                        setAddListResultData([]);
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                    }
                    else if (success.length > 0 && fail.length > 0) {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, pTag: {
                                p1: `성공 ${success.length} 건 입니다.`,
                                p2: `실패 ${fail.length} 건 입니다.`,
                            } }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "삭제를 실패했습니다" }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                userTypeSelect(type);
            }
            CUTIL.inner_jsclose_Popup("pop-role");
        });
    }
    function usertypePop(e, type) {
        CUTIL.jsopen_InteriorPopup(e);
        setUserTypeItme(type);
        setChecked(true);
    }
    // 승인 API
    function approvalChang(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/user/${list.id}/approval`,
                appQuery: {
                    approval: 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setUser(Object.assign(Object.assign({}, user), { approval: 2 }));
                    setEanbled(true);
                    setReload(true);
                    setUserDisplayCompanion(false);
                    setUserDisplayDone(true);
                }
            }
        });
    }
    // 반려 display
    function onCompanion(e, list) {
        if (userDisplayCompanion === false) {
            setUserDisplayCompanion(true);
            setUserDisplayDone(false);
        }
        else if (list.enabled == false) {
            setUserDisplayCompanion(false);
        }
    }
    // 승인 선택
    function onDone(e) {
        if (userDisplayDone === false) {
            setUserDisplayDone(true);
            setUserDisplayCompanion(false);
        }
    }
    // ApprovalPop - site addPop ListAdd
    function listAdd(e, companyAdd, zoneAdd, list) {
        var listVal = {
            userIdPk: list.userIdPk,
            companyId: companyAdd.companyId,
            companyName: companyAdd.companyName,
            zoneId: zoneAdd.zoneId,
            zoneName: zoneAdd.zoneName,
            address: zoneAdd.address,
        };
        if (zoneAdd != "") {
            setAddList([...addList, listVal]);
        }
    }
    // ApprovalPop - site addPop ListDelete
    function listDelete(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            if (list.id) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "DELETE",
                    appPath: `/product/usertree/user/${user.id}`,
                    appQuery: {
                        productId: list.productId,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setReload(true);
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "데이터가 삭제되었습니다." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setAddListResultData(addListResultData.filter((delList) => delList.id !== list.id));
                        setReload(false);
                    }
                    else {
                        // 기존 기기 존재 시
                        if (data.codeNum == 9999) {
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "데이터가 삭제되었습니다." }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                            setErrorList(data.errorList);
                            // alert(data.body.errorList[0].msg);
                        }
                    }
                }
            }
            else {
                setAddList(addList.filter((delList) => delList.zoneId !== list.zoneId));
                setAddListResult(addListResult.filter((delList) => delList.zoneId !== list.zoneId));
            }
        });
    }
    // 회사 목록 API
    function companySelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.jsopen_InteriorPopup(e);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: "/product/companies",
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (userType == CONST.USERROLE_ENGINEER) {
                        setCompanyItem(data.body);
                        companyClick(null);
                    }
                    else {
                        let companyArr = null;
                        data.body.filter((cf) => cf.companyName == user.companyName).map((item) => (companyArr = item));
                        companyClick(companyArr);
                    }
                }
            }
        });
    }
    // 회사 선택 시 사업장 API 연계까지
    function companyClick(company) {
        return __awaiter(this, void 0, void 0, function* () {
            if (company) {
                // 셀렉트 선택 시 data
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/product/zones`,
                    appQuery: {
                        language: langApi,
                        companyId: company.companyId,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setZoneItem(data.body);
                        setCompanyAdd(company);
                        setZoneAdd([]);
                    }
                }
            }
            else {
                setZoneItem([]);
                setCompanyAdd([]);
                setZoneAdd([]);
            }
        });
    }
    // 사업장 이벤트
    function zoneClick(e, zone) {
        setZoneAdd(zone);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: selTree.company.companyName })) })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsx("span", Object.assign({ className: "mr-24" }, { children: _jsx("strong", { children: "\uC0AC\uC6A9\uC790 \uD0C0\uC785" }) })), _jsxs("div", Object.assign({ className: "select w200", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", onClick: (e) => setRole(role) }, { children: role.length > 0 ? role : "전체" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => setRole("") }, { children: "\uC804\uCCB4" })), roleType.map((role) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => setRole(role.value) }, { children: role.fname }), "role_" + role.id)))] })] }))] })) })) })) })), _jsx("div", Object.assign({ className: "tbl-list userlist" }, { children: _jsxs("table", Object.assign({ summary: "\uB4F1\uB85D \uC21C,\uC0AC\uC6A9\uC790 \uD0C0\uC785,\uD68C\uC0AC,\uC0AC\uC5C5\uC7A5,\uC774\uB984,E-mail(ID),\uC5F0\uB77D\uCC98,\uB2F4\uB2F9 \uC0AC\uC5C5\uC7A5,\uB9C8\uC9C0\uB9C9 \uB85C\uADF8\uC778,\uC2B9\uC778\uC0C1\uD0DC \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0AC\uC6A9\uC790 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC0AC\uC6A9\uC790 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "90px" } }), _jsx("col", { style: { width: "125px" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "90px" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "120px" } }), _jsx("col", { style: { width: "108px" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "100px" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "rownumber" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "rownumber" }, { children: _jsx("span", { children: "\uB4F1\uB85D \uC21C" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "role" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"} pl-22`, onClick: (e) => onClickSort(e), "data-value": "role" }, { children: _jsx("span", { children: "\uC0AC\uC6A9\uC790 \uD0C0\uC785" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uD68C\uC0AC" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC774\uB984" })), _jsx("th", Object.assign({ scope: "col" }, { children: "E-mail(ID)" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC5F0\uB77D\uCC98" })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "zoneCount" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "zoneCount" }, { children: _jsx("span", { children: "\uB2F4\uB2F9 \uC0AC\uC5C5\uC7A5" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "loginTime" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "loginTime" }, { children: _jsx("span", { children: "\uB9C8\uC9C0\uB9C9 \uB85C\uADF8\uC778" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "approval" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"} txt-left `, onClick: (e) => onClickSort(e), "data-value": "approval" }, { children: _jsx("span", { children: "\uC2B9\uC778\uC0C1\uD0DC" }) }))] }) }), _jsx("tbody", { children: users.length > 0 &&
                                            users.map((list, idx) => (_jsxs("tr", Object.assign({ className: "js-open", "data-pop": "pop-admin-ok", onClick: (e) => approvalPop(e, list) }, { children: [_jsx("td", Object.assign({ "data-pop": "pop-admin-ok" }, { children: list.rowNumber })), _jsx("td", Object.assign({ className: `${list.enable == false && list.role === CONST.USERROLE_NONE
                                                            ? "icon-dot disabled"
                                                            : list.role !== CONST.USERROLE_NONE && list.enable == false
                                                                ? "disabled"
                                                                : ""}  pl-22`, "data-pop": "pop-admin-ok" }, { children: _jsx("span", Object.assign({ "data-pop": "pop-admin-ok" }, { children: roleType.filter((rd) => rd.value === list.role).length > 0
                                                                ? roleType.filter((rd) => rd.value === list.role).map((rd) => rd.fname)
                                                                : roleType[1].fname })) })), _jsx("td", Object.assign({ className: `${list.enable == false && list.role === CONST.USERROLE_NONE
                                                            ? "icon-dot disabled"
                                                            : list.role !== CONST.USERROLE_NONE && list.enable == false
                                                                ? "disabled"
                                                                : ""}`, "data-pop": "pop-admin-ok" }, { children: list.companyName })), _jsx("td", Object.assign({ className: `${list.enable == false && list.role === CONST.USERROLE_NONE
                                                            ? "icon-dot disabled"
                                                            : list.role !== CONST.USERROLE_NONE && list.enable == false
                                                                ? "disabled"
                                                                : ""}`, "data-pop": "pop-admin-ok" }, { children: list.userName })), _jsx("td", Object.assign({ className: `${list.enable == false && list.role === CONST.USERROLE_NONE
                                                            ? "icon-dot disabled"
                                                            : list.role !== CONST.USERROLE_NONE && list.enable == false
                                                                ? "disabled"
                                                                : ""}`, "data-pop": "pop-admin-ok" }, { children: _jsx("p", Object.assign({ className: "ellipsis", "data-pop": "pop-admin-ok" }, { children: list.userId })) })), _jsx("td", Object.assign({ className: `${list.enable == false && list.role === CONST.USERROLE_NONE
                                                            ? "icon-dot disabled"
                                                            : list.role !== CONST.USERROLE_NONE && list.enable == false
                                                                ? "disabled"
                                                                : ""}`, "data-pop": "pop-admin-ok" }, { children: list.phoneNumber })), _jsx("td", Object.assign({ className: `${list.enable == false && list.role === CONST.USERROLE_NONE
                                                            ? "icon-dot disabled"
                                                            : list.role !== CONST.USERROLE_NONE && list.enable == false
                                                                ? "disabled"
                                                                : ""}`, "data-pop": "pop-admin-ok" }, { children: list.zoneCount })), _jsx("td", Object.assign({ className: `${list.enable == false && list.role === CONST.USERROLE_NONE
                                                            ? "icon-dot disabled"
                                                            : list.role !== CONST.USERROLE_NONE && list.enable == false
                                                                ? "disabled"
                                                                : ""}`, "data-pop": "pop-admin-ok" }, { children: _jsx("p", Object.assign({ className: "ellipsis", "data-pop": "pop-admin-ok" }, { children: CUTIL.utc2time("YYYY-MM-DD", list.loginTime) })) })), _jsx("td", Object.assign({ "data-pop": "pop-admin-ok" }, { children: list.approval == 1 ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-blue", "data-pop": "pop-admin-ok" }, { children: _jsx("span", Object.assign({ "data-pop": "pop-admin-ok" }, { children: "\uC2B9\uC778 \uC694\uCCAD" })) }))) : list.approval == 2 ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-navy", "data-pop": "pop-admin-ok" }, { children: _jsx("span", Object.assign({ "data-pop": "pop-admin-ok" }, { children: "\uC2B9\uC778 \uC911" })) }))) : ("") }))] }), "userMng_" + idx))) })] })) }))] }))] })) }));
}
// 신규 가입자요청 팝업
function RequestApproval(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    // useState
    const [list, setList] = useState(null);
    const [companionTxt, setCompanionTxt] = useState("");
    // props
    const { user, roleType, userType, userTypeSelect, errorList, approvalChang, userDisplayDone, userDisplayCompanion, onCompanion, onDone, addListResult, addListResultData, listDelete, companySelect, setErrorList, setReload, enableItem, setAddList, setAddListResult, usertypePop, } = props;
    useEffect(() => {
        setList(user);
        // if (user && user.approval > 2) {
        // }
    }, [user]);
    useEffect(() => {
        setCompanionTxt("");
    }, [userDisplayCompanion]);
    // 반려 완료
    function userApprovalDel(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/user/${list.id}/approval`,
                appQuery: {
                    approval: 0,
                    deniedReason: companionTxt,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "메일 전송이 완료되었습니다." }));
                    setAddList([]);
                    setAddListResult([]);
                    CUTIL.jsclose_Popup("pop-admin-ok");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    // window.location.reload();
                }
                else {
                    setErrorList(data.errorList);
                }
            }
        });
    }
    // 승인 완료
    function userApprovalDone(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/auth/user/${list.id}/roleusertree`,
                appQuery: {
                    role: userType,
                    usertree: addListResult.map((el) => ({
                        product: "zone",
                        productName: el.zoneName,
                        productParentId: el.companyId,
                        approval: 2,
                        isontree: true,
                    })),
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "사용자 승인 요청이 완료되었습니다." }));
                    setAddList([]);
                    setAddListResult([]);
                    CUTIL.jsclose_Popup("pop-admin-ok");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    setErrorList(data.errorList);
                }
            }
        });
    }
    // 승인 수정
    function userApprovalUdpate(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/auth/user/${list.id}/roleusertree`,
                appQuery: {
                    role: userType,
                    usertree: addListResult.map((el) => ({
                        product: "zone",
                        productName: el.zoneName,
                        productParentId: el.companyId,
                        approval: 2,
                        isontree: true,
                    })),
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "사용자 타입이 수정되었습니다." }));
                    setAddList([]);
                    setAddListResult([]);
                    CUTIL.jsclose_Popup("pop-admin-ok");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    setErrorList(data.errorList);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "flex-row m-mt-16" }, { children: [_jsx("div", Object.assign({ className: "pop-left" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-0" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: "E-mail (\uC544\uC774\uB514)\uBA85" })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: (list && list.userId) || "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: "\uC774\uB984\uBD84\uB958" })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: (list && list.userName) || "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: "\uC5F0\uB77D\uCC98" })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: (list && list.phoneNumber) || "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: "\uD68C\uC0AC" })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: (list && list.companyName) || "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: "\uBD80\uC11C" })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: list && list.department ? list.department : "-", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: "\uC5C5\uC885" })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: (list && list.classification) || "", readOnly: true }) }))] }), user && user.approval <= 2 && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star w185" }, { children: "\uC2B9\uC778\uC5EC\uBD80" })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsxs("div", Object.assign({ className: "flex-inline" }, { children: [_jsx("button", Object.assign({ type: "button", className: `btn-basic h40 w136 ${userDisplayDone ? "bg-navy" : ""}`, onClick: (e) => (user.approval < 2 ? approvalChang(user) : onDone(e)) }, { children: _jsx("span", Object.assign({ className: "font-16 fontBold" }, { children: user.approval < 1 ? "승인1" : "승인" })) })), _jsx("button", Object.assign({ type: "button", "data-pop": "pop-admin-ban", className: `btn-basic h40 w136 ml-8 ${userDisplayCompanion ? "bg-navy" : ""}`, onClick: (e) => onCompanion(e) }, { children: _jsx("span", Object.assign({ className: "font-16 fontBold", "data-pop": "pop-admin-ban" }, { children: "\uBC18\uB824" })) }))] })) }))] })), user && user.approval > 2 && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: "\uC0AC\uC6A9\uC790 \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsxs("div", Object.assign({ className: "flex-inline" }, { children: [_jsx("button", Object.assign({ type: "button", className: `btn ${!enableItem ? "btn-off" : "btn-on"}`, "data-pop": "pop-enabled", onClick: (e) => CUTIL.jsopen_InteriorPopup(e) }, { children: _jsx("span", Object.assign({ className: "hide", "data-pop": "pop-enabled" }, { children: !enableItem ? "비활성화" : "활성화" })) })), user.accountLocked ? (_jsx("button", Object.assign({ type: "button", className: "btn txtline txt-gray ml-10", "data-pop": "pop-unlock", onClick: (e) => CUTIL.jsopen_InteriorPopup(e) }, { children: _jsx("span", Object.assign({ className: "font-14 txt-red", "data-pop": "pop-unlock" }, { children: "\uACC4\uC815 \uC7A0\uAE08 \uD574\uC81C" })) }))) : (_jsx("button", Object.assign({ type: "button", className: "btn txtline txt-gray ml-10", "data-pop": "pop-password", onClick: (e) => CUTIL.jsopen_InteriorPopup(e) }, { children: _jsx("span", Object.assign({ className: "font-14 txt-gray", "data-pop": "pop-password" }, { children: "\uD328\uC2A4\uC6CC\uB4DC \uCD08\uAE30\uD654" })) })))] })) }))] }))] })) })), _jsx("div", Object.assign({ className: "pop-right w100p" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-0" }, { children: [!userDisplayCompanion && (_jsx(IsSavedApproval, { user: user, enableItem: enableItem, roleType: roleType, userType: userType, userTypeSelect: userTypeSelect, approvalChang: approvalChang, userDisplayDone: userDisplayDone, userDisplayCompanion: userDisplayCompanion, onCompanion: onCompanion, onDone: onDone, errorList: errorList, addListResult: addListResult, listDelete: listDelete, companySelect: companySelect, addListResultData: addListResultData, usertypePop: usertypePop })), userDisplayCompanion && (_jsx(Companion, { errorList: errorList, companionTxt: companionTxt, setCompanionTxt: setCompanionTxt }))] })) }))] })) })), _jsx("div", Object.assign({ className: "popup__footer" }, { children: userDisplayCompanion ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => userApprovalDel(user) }, { children: _jsx("span", { children: "\uC644\uB8CC" }) }))) : userDisplayDone && user.approval < 3 ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => userApprovalDone(user) }, { children: _jsx("span", { children: "\uC644\uB8CC" }) }))) : user && user.approval >= 3 && enableItem ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => userApprovalUdpate(user) }, { children: _jsx("span", { children: "\uC644\uB8CC" }) }))) : (_jsx("button", Object.assign({ type: "button", disabled: true }, { children: _jsx("span", { children: "\uC644\uB8CC" }) }))) }))] }));
}
// 신규 가입자 승인
function IsSavedApproval(props) {
    // props
    const { user, roleType, enableItem, userType, userTypeSelect, userDisplayDone, errorList, addListResult, listDelete, companySelect, addListResultData, usertypePop, } = props;
    useEffect(() => { }, [roleType, userType, userTypeSelect, userDisplayDone, addListResult, listDelete, errorList]);
    // 중복제거 이벤트
    const addLists = addListResult.filter((arr, index, callback) => index === callback.findIndex((t) => t.zoneId === arr.zoneId));
    return (_jsxs(_Fragment, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star w185" }, { children: "\uC0AC\uC6A9\uC790 \uD0C0\uC785" })), _jsxs("div", Object.assign({ className: "input__area w375" }, { children: [_jsx("div", Object.assign({ className: `radioBox
              ${errorList.filter((err) => err.field === "role").length > 0 ? "input-error" : ""}` }, { children: user && user.approval < 3
                                    ? roleType
                                        .filter((type) => type.id != 0)
                                        .map((type) => (_jsxs("label", Object.assign({ id: "rd_" + type.id }, { children: [_jsx("input", { type: "radio", id: "rd_" + type.id, name: "rd", value: type.value === userType ? type.value : type.value, checked: userType && userType === type.value ? true : false, onChange: (e) => userTypeSelect(type), disabled: user.approval < 2 ? true : false }), type.fname] }), type.id)))
                                    : roleType
                                        .filter((type) => type.id != 0)
                                        .map((type) => (_jsxs("label", Object.assign({ id: "rd_" + type.id }, { children: [_jsx("input", { type: "radio", id: "rd_" + type.id, name: "rd", className: "js-open", "data-pop": "pop-role", value: type.value === userType ? type.value : type.value, checked: userType && userType === type.value ? true : false, onChange: (e) => usertypePop(e, type), disabled: !enableItem ? true : false }), type.fname] }), type.id))) })), _jsxs("p", Object.assign({ className: "input-errortxt" }, { children: ["\uD544\uC218 \uC785\uB825\uD56D\uBAA9 \uC785\uB2C8\uB2E4.", errorList.filter((err) => err.field === "role").map((err) => err.msg)] }))] }))] }), _jsx("li", { children: _jsxs("div", Object.assign({ className: "flex-column" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top w100p" }, { children: [_jsx("p", Object.assign({ className: "tit mt-0" }, { children: "\uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D" })), user && user.approval < 3 ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic", "data-pop": "pop-user-add", onClick: (e) => companySelect(e), disabled: !userDisplayDone ||
                                        (userType && userType == CONST.USERROLE_ADMIN) ||
                                        (userType && userType == CONST.USERROLE_SUPER) ||
                                        enableItem == false
                                        ? true
                                        : false }, { children: _jsx("span", { children: "\uCD94\uAC00" }) }))) : (_jsx("button", Object.assign({ type: "button", className: "btn-basic", "data-pop": "pop-user-add", onClick: (e) => companySelect(e), disabled: (userType && userType == CONST.USERROLE_ADMIN) ||
                                        (userType && userType == CONST.USERROLE_SUPER) ||
                                        enableItem == false
                                        ? true
                                        : false }, { children: _jsx("span", { children: "\uCD94\uAC00" }) })))] })), _jsx("div", Object.assign({ className: "tbl-list scrollH h295" }, { children: _jsxs("table", Object.assign({ summary: "No,\uD68C\uC0AC \uBA85,\uC0AC\uC5C5\uC7A5 \uBA85 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "40%" } }), _jsx("col", { style: { width: "40%" } }), _jsx("col", { style: { width: "10%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uD68C\uC0AC \uBA85" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC0AC\uC5C5\uC7A5 \uBA85" })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }) }), _jsxs("tbody", { children: [addListResultData &&
                                                addListResultData.map((treeList, idx) => (_jsxs("tr", { children: [_jsx("td", Object.assign({ className: "txt-left" }, { children: ++idx })), _jsx("td", Object.assign({ className: "txt-left" }, { children: treeList.productParentId })), _jsx("td", Object.assign({ className: "txt-left" }, { children: _jsx("span", Object.assign({ className: "icon-navi" }, { children: treeList.productName })) })), _jsx("td", { children: enableItem == true ? (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete-g", onClick: (e) => listDelete(treeList) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))) : ("") })] }, treeList.id))), addLists &&
                                                addLists.map((add, idx) => (_jsxs("tr", { children: [_jsx("td", { children: ++idx }), _jsx("td", { children: add.companyName }), _jsx("td", { children: add.zoneName }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-g", onClick: (e) => listDelete(add) }, { children: _jsx("span", { className: "hide" }) })) })] }, add.zoneId)))] })] })) }))] })) }), _jsx("p", Object.assign({ className: "txt-info txt-middlegray font-13 ml-0 mt-4" }, { children: "* \uC0AC\uC6A9\uC790 \uD0C0\uC785 \uBCC0\uACBD \uC2DC [User]\uD0C0\uC785\uC73C\uB85C \uB4F1\uB85D\uB41C [\uD68C\uC0AC_\uC0AC\uC5C5\uC7A5] \uBAA9\uB85D\uC740 \uCD08\uAE30\uD654 \uB429\uB2C8\uB2E4." }))] }));
}
// 신규가입자- 반려
function Companion(props) {
    const { companionTxt, setCompanionTxt, errorList } = props;
    return (_jsx(_Fragment, { children: _jsxs("li", Object.assign({ className: "flex-column" }, { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uBC18\uB824 \uC0AC\uC720" })), _jsxs("div", Object.assign({ className: "input__area mt-19" }, { children: [_jsx("textarea", { rows: 2, className: `h186 ${errorList.filter((err) => err.field === "deniedReason").length > 0 ? "input-error" : ""}`, placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: companionTxt, onChange: (e) => setCompanionTxt(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "deniedReason").map((err) => err.msg) }))] }))] })) }));
}
//신규 가입자 - site 등록
function CompanyZoneCreatePop(props) {
    // props
    const { user, userType, companyClick, companyItem, companyAdd, zoneItem, zoneAdd, setZoneAdd, addList, listDelete, setAddList, setAddListResult, } = props;
    const [zoneInfo, setZoneInfo] = useState(null);
    // 사업장 이벤트
    function zoneClick(zone) {
        setZoneAdd(zone);
        setZoneInfo(zone);
        var listVal = {
            userIdPk: user.id,
            companyId: companyAdd.companyId,
            companyName: companyAdd.companyName,
            zoneId: zone.zoneId,
            zoneName: zone.zoneName,
            address: zone.address,
        };
        setAddList([...addList, listVal]);
    }
    // 회사_사업장 등록 이벤트
    function CompanyZoneAdd(list) {
        return __awaiter(this, void 0, void 0, function* () {
            setAddListResult(list);
            CUTIL.inner_jsclose_Popup("pop-user-add");
        });
    }
    function CloseInnerPop(id) {
        setAddListResult([]);
        CUTIL.inner_jsclose_Popup(id);
    }
    // 중복제거 이벤트
    const addLists = addList.filter((arr, index, callback) => index === callback.findIndex((t) => t.zoneId === arr.zoneId));
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("div", Object.assign({ className: "tbl__top mb-24" }, { children: _jsxs("div", Object.assign({ className: "left" }, { children: [_jsx("span", Object.assign({ className: "mr-16 font-14 star" }, { children: _jsx("strong", { children: "\uD68C\uC0AC \uBA85" }) })), userType && userType == CONST.USERROLE_ENGINEER ? (_jsxs("div", Object.assign({ className: "select w278", id: "company", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD558\uC138\uC694" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ id: "company_change", className: "option hide", onClick: (e) => companyClick("") }, { children: "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD558\uC138\uC694" })), companyItem &&
                                                    companyItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => companyClick(list) }, { children: list.companyName }), "companyList_" + idx.toString())))] })] }))) : (_jsx("div", Object.assign({ className: " w278", id: "company" }, { children: _jsx("input", { type: "text", id: "", value: (user && user.companyName) || "", readOnly: true }) }))), _jsx("span", Object.assign({ className: "ml-48 mr-16 font-14 star" }, { children: _jsx("strong", { children: "\uC0AC\uC5C5\uC7A5 \uBA85" }) })), _jsxs("div", Object.assign({ className: "select w278", id: "zone", onClick: (e) => companyAdd.companyId && CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: zoneAdd.length <= 0 ? "클릭하여 선택하세요" : zoneInfo.zoneName })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ id: "zone_change", className: "option hide", onClick: (e) => zoneClick("") }, { children: "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD558\uC138\uC694" })), zoneItem &&
                                                    zoneItem.map((list) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => zoneClick(list) }, { children: list.zoneName }), list.zoneId)))] })] }))] })) })), _jsx("div", Object.assign({ className: "tbl-list scrollH h336 mb-32" }, { children: _jsxs("table", Object.assign({ summary: "No,\uD68C\uC0AC \uBA85,\uC0AC\uC5C5\uC7A5 \uBA85 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "47%" } }), _jsx("col", { style: { width: "8%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uD68C\uC0AC \uBA85" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC0AC\uC5C5\uC7A5 \uBA85" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC8FC\uC18C" })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }) }), _jsx("tbody", { children: addLists &&
                                        addLists.map((add, idx) => (_jsxs("tr", { children: [_jsx("td", { children: ++idx }), _jsx("td", { children: add.companyName }), _jsx("td", { children: add.zoneName }), _jsx("td", { children: add.address }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-g", onClick: (e) => listDelete(add) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }, add.zoneId))) })] })) }))] })), _jsxs("div", Object.assign({ className: "popup__footer right" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => CloseInnerPop("pop-user-add") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", className: "mr-15 js-close", onClick: (e) => CompanyZoneAdd(addLists) }, { children: _jsx("span", { children: "\uB4F1\uB85D" }) }))] }))] }));
}
function PassswordPop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { user } = props;
    function onClickInit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/auth/password/init`,
                appQuery: {
                    userId: user.userId,
                    userName: user.userName,
                    phoneNumber: user.phoneNumber,
                    language: user.language,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.inner_jsclose_Popup("pop-password");
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "사용자 비밀번호가 초기화 되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [user && (_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uD574\uB2F9 \uC0AC\uC6A9\uC790 \uD328\uC2A4\uC6CC\uB4DC\uAC00 \uCD08\uAE30\uD654 \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }) }))), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => CUTIL.inner_jsclose_Popup("pop-password") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", className: "close", onClick: (e) => onClickInit(e) }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] }));
}
function EnabledPop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    // props
    const { user, enableItem, setReload, setEnableItem } = props;
    function onClickEnalbe(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/user/${user.id}/enable`,
                appQuery: {
                    enabled: !enableItem,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.inner_jsclose_Popup("pop-enabled");
                    setReload(true);
                    setEnableItem(!enableItem ? true : false);
                    setReload(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [user && (_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsxs("p", { children: ["\uD574\uB2F9 \uC0AC\uC6A9\uC790\uB97C ", enableItem == true ? "비활성화" : "활성화", "\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"] }), _jsxs("p", { children: [enableItem == true ? "비활성화" : "활성화", " \uC2DC \uC0AC\uC6A9\uC790\uC758 Beyond X\u2122 Enable \uC0AC\uC6A9\uC774", " ", enableItem == true ? "정지" : "승인", " \uB429\uB2C8\uB2E4."] })] }))), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => CUTIL.inner_jsclose_Popup("pop-enabled") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", className: "close", onClick: (e) => onClickEnalbe(e) }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] }));
}
/**
 * 계정 잠금 해제 팝업
 * 비밀번호 연속 불일치 임계치(기본 5회) 도달로 잠긴 계정을 관리자가 해제한다.
 */
function UnlockPop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { user, setUser, setReload } = props;
    function onClickUnlock() {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/auth/user/${user.id}/unlock`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.inner_jsclose_Popup("pop-unlock");
                    setUser(Object.assign(Object.assign({}, user), { accountLocked: false, loginFailCount: 0 }));
                    setReload(true);
                    setReload(false);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "계정 잠금이 해제되고 새 비밀번호가 이메일로 전송되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [user && (_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("p", { children: "\uD574\uB2F9 \uC0AC\uC6A9\uC790\uC758 \uACC4\uC815 \uC7A0\uAE08\uC744 \uD574\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }), _jsx("p", { children: "\uBE44\uBC00\uBC88\uD638\uB97C \uC5F0\uC18D\uC73C\uB85C \uC798\uBABB \uC785\uB825\uD558\uC5EC \uC7A0\uAE34 \uACC4\uC815\uC785\uB2C8\uB2E4. \uD574\uC81C \uC2DC \uC2E4\uD328 \uD69F\uC218\uAC00 \uCD08\uAE30\uD654\uB418\uACE0 \uB2E4\uC2DC \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4." })] }))), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => CUTIL.inner_jsclose_Popup("pop-unlock") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", className: "close", onClick: (e) => onClickUnlock() }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] }));
}
function RolePop(props) {
    // props
    const { user, userTypeDel, userTypeItme } = props;
    useEffect(() => { }, [userTypeDel]);
    return (_jsxs(_Fragment, { children: [user && (_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("p", { children: "\uD574\uB2F9 \uC0AC\uC6A9\uC790 \uD0C0\uC785\uC744 \uBCC0\uACBD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uB07C?" }), _jsx("p", { children: "\uBCC0\uACBD \uC2DC \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uB4F1\uB85D\uB41C \uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D\uC774 \uCD08\uAE30\uD654 \uB429\uB2C8\uB2E4." })] }))), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => CUTIL.inner_jsclose_Popup("pop-role") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", className: "close", onClick: (e) => userTypeDel(userTypeItme) }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] }));
}
